import React, { useState } from "react"
import moment from "moment"
import { Popover } from "@mui/material"
import "./PendingAppointmentsComponent.scss"
import Button from "../../../../components/Button"
import { IAppointmentDetail } from "../../../../core/services/models/AppointmentDetail"
import { updateAppointment } from "../../../../core/services/api"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { isAfter, subDays } from "date-fns"

interface IPendingAppointmentProps {
  tabs: Array<any>
  appointments: Array<IAppointmentDetail> | undefined
  appointmentsCount: any
  userRole: any
  centerDetail: any,
  onPopupOpen: (event: any) => void
  onClose: () => void
  onReschedule: (event: any) => void
  onToastDisplay: (event: any) => void
  onCancel: (event: any) => void,
  disabledAppointments: any
}
interface DisabledApprove {
  [key: string]: boolean;
}

export default function PendingAppointmentsComponent({
  tabs,
  appointments,
  appointmentsCount,
  userRole,
  centerDetail,
  onPopupOpen,
  onClose,
  onReschedule,
  onToastDisplay,
  onCancel,
  disabledAppointments
}: React.PropsWithChildren<IPendingAppointmentProps>) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? "pending-appointment-popover" : undefined

  const [reason, setReason] = useState<any>()
  const [type, setType] = useState<string>()

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
    onPopupOpen(event?.currentTarget?.id)
    setType(event?.currentTarget?.id)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  function displayScheduleTime(time: any) {
    return moment(time, "HH:mm").format("hh:mm A")
  }

  const [disabledApprove, setDisabledApprove] = useState<DisabledApprove>({});
  const setApproveDisabled = (appointmentId: any, isDisabled: boolean) => {
    setDisabledApprove(prevState => ({
      ...prevState,
      [appointmentId]: isDisabled,
    }));
  };

  const checkAppointmentEditable = (dateToCheck: any) => {
    const twoDaysAgo = subDays(new Date(), 2);
    return isAfter(new Date(dateToCheck), twoDaysAgo);
  };

  function onStatusChange(eachAppointment: any, status: string) {

    const appointmentId = eachAppointment?.id;
    setApproveDisabled(appointmentId, true);
    let tempAppointment = Object.assign({}, eachAppointment)
    tempAppointment.status = status

    delete tempAppointment["patientName"]
    delete tempAppointment["gender"]
    delete tempAppointment["age"]
    delete tempAppointment["primaryPhoneNumber"]
    delete tempAppointment["email"]
    delete tempAppointment["isVIP"]
    delete tempAppointment["allottedBed"]
    delete tempAppointment["invoiceId"]
    delete tempAppointment["isEditable"]
    delete tempAppointment["dob"]
    delete tempAppointment["medicalRecordsId"]
    delete tempAppointment["bedIsVacant"]
    delete tempAppointment["bedMadeVacantAt"]
    delete tempAppointment["mocAppointmentId"]
    delete tempAppointment["oldDocuments"]
    delete tempAppointment["serviceName"]
    delete tempAppointment["finalInvoiceAmount"]




    updateAppointment(tempAppointment)
      .then((res) => {
        setApproveDisabled(appointmentId, false);
        onPopupOpen(eachAppointment?.appointmentType)
        onToastDisplay({
          text: `Appointment has been ${status === "BOOKED"
            ? "approved"
            : status === "CANCELLED"
              ? "rejected"
              : "updated"
            } successfully.`,
          type: "success",
        })
      })
      .catch((err) => {
        setApproveDisabled(appointmentId, false);
        console.log("err in appointment status change", err)
        onToastDisplay({ text: "The appointment service might have been deleted or updated, Please re-book the appointment", type: "error" })
      })
  }

  function renderAppointmentCard(eachAppointment: IAppointmentDetail) {
    const isRescheduleDisabled = disabledAppointments[eachAppointment?.id] === true;
    const isApproveDisabled = disabledApprove[eachAppointment?.id] === true;
    const isNotEditable = !checkAppointmentEditable(eachAppointment?.scheduleDate)

    return (
      <div className="appointment-card">
        <div className="profile-data">
          <div className="name">
            {PermissionUtils.displayPatientName(
              userRole,
              eachAppointment,
              true,
              null,
              null
            )}
          </div>
          {eachAppointment?.appointmentType === "IPD" && (<div className="description">{eachAppointment?.allottedBed ? `Room: ${eachAppointment?.allottedBed?.roomName} Bed: ${eachAppointment?.allottedBed?.bedName}` : "Bed allotment is not done yet."}</div>)}

          <div className="description">
            {eachAppointment?.scheduleDate
              ? moment(eachAppointment?.scheduleDate).format("DD-MM-YYYY")
              : null}{" at"} &nbsp;

            {eachAppointment?.allottedBed?.slots?.length > 0 ?
              displayScheduleTime(eachAppointment?.allottedBed?.slots[0])
              : eachAppointment?.slots && eachAppointment?.slots[0]
                ? displayScheduleTime(eachAppointment?.slots[0])
                : ""}{" "}
            {
              eachAppointment?.allottedBed?.slots?.length > 0 && (
                <span className="time">
                  for{" "}
                  {eachAppointment?.allottedBed?.slots?.length === 1
                    ? centerDetail?.bedSlotDuration
                    : (eachAppointment?.allottedBed?.slots?.length - 1) * centerDetail?.bedSlotDuration}{" "}
                  mins
                </span>
              )
            }
            {
              eachAppointment?.slots?.length > 0 && (
                <span className="time">
                  for{" "}
                  {eachAppointment?.slots?.length === 1
                    ? centerDetail?.slotDuration
                    : (eachAppointment?.slots?.length - 1) * centerDetail?.slotDuration}{" "}
                  mins
                </span>
              )
            }

          </div>
          <div className="description d-flex align-center gap-10">
            {eachAppointment?.primaryPhoneNumber ? (
              <div className="phone-email">
                <img
                  alt="phone"
                  className="icon"
                  src={"../../../assets/images/phoneIcon.svg"}
                />
                <div className="text">
                  {eachAppointment?.primaryPhoneNumber}
                </div>
              </div>
            ) : null}

            {eachAppointment?.email ? (
              <div className="phone-email">
                <img
                  alt="email"
                  className="icon"
                  src={"../../../assets/images/emailIcon.svg"}
                />
                <div className="text">{eachAppointment?.email}</div>
              </div>
            ) : null}
          </div>

          <div className="button-group">
            <Button
              text="Reschedule"
              outline={true}
              onClick={() => onReschedule(eachAppointment)}
              id="reschedule"
              disabled={isRescheduleDisabled || isNotEditable}
            />
            <Button
              text="Reject"
              outline={true}
              onClick={() => onCancel(eachAppointment)}
              id="reject"
              disabled={isRescheduleDisabled || isNotEditable}
            />
            {(eachAppointment?.appointmentType === "OPD" || eachAppointment?.appointmentType === "HC" || (eachAppointment?.appointmentType === "IPD" && eachAppointment?.allottedBed?.roomName)) ? (<Button
              text="Approve"
              disabled={isApproveDisabled || isNotEditable}
              onClick={() => onStatusChange(eachAppointment, "BOOKED")}
            />) : null}
          </div>
        </div>
      </div>
    )
  }

  function renderChip(title: string, count: number) {
    return (
      <div key={title} id={title} className={`${title === "SPR" ? "" : "chip"}`}>
        {title === "SPR" ? "" :
          <div
            className="col-md-12 row m-0"
            id={title}
            onClick={(event) => handleClick(event)}
          >
            <div id={title} className="d-flex align-center col-10 p-0">
              <span>{title} - </span>
              <span className="count">{count}</span>
            </div>
            <span className="col-md-2 p-0">
              <img
                alt="downarrow"
                className="downarrow"
                src={"../../assets/images/Downarrow.svg"}
              />
            </span>

          </div>
        }

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          sx={{ width: "100%" }}
        >
          <div className="pending-appointment-popover">
            <div className="header">
              <div className="title">Pending appointment request</div>
              <div className="d-flex align-center">
                <div className="type">{type} -</div>
                {/* {console.log(type, "type")} */}

                <div className="totalCount">{appointments?.length}</div>
              </div>
            </div>

            <div className="appointments-list">
              {appointments && appointments.length > 0 ? (
                appointments.map((each: IAppointmentDetail) =>
                  renderAppointmentCard(each)
                )
              ) : (
                <div className="empty-state">No appointments </div>
              )}
            </div>
          </div>
        </Popover>
      </div>
    )
  }

  return (
    <div className="pending-appointment-section d-flex align-center col-md-12">
      <div className="d-flex align-center">
        <img
          src={"../../assets/images/warning.svg"}
          className="warning"
          alt="warning"
        />
        <div className="header">
          Pending <br /> Appointments
        </div>
      </div>
      {renderChip("ALL", appointmentsCount?.allPendingAppointments)}
      {/* {console.log(tabs, "tabs")} */}

      {tabs?.map((eachChip) =>
        renderChip(
          eachChip?.title,
          appointmentsCount &&
            appointmentsCount[
              `${eachChip?.title?.toLowerCase()}PendingAppointments`
            ]?.toString()
            ? appointmentsCount[
              `${eachChip?.title?.toLowerCase()}PendingAppointments`
            ]?.toString()
            : null
        )
      )}

      <div className="closebutton d-none">
        <img
          src="../../assets/images/close-icon.svg"
          height="14px"
          width="14px"
          alt="close icon"
          onClick={() => onClose()}
        />
      </div>
    </div>
  )
}
